export default __webpack_public_path__ + "static/media/minivistaw-FOCUS-RESET.74a3aca5.jpg";